var _g, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoDataAvailable({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 133,
    viewBox: "0 0 121 133",
    fill: "none",
    id: "svg4",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14075_117895)",
    id: "g1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 73,
    r: 59,
    stroke: "white",
    strokeWidth: 2,
    id: "circle1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3599 53.6484C33.0902 53.6475 32.8308 53.7542 32.6401 53.9448C32.4495 54.1359 32.3429 54.3948 32.3438 54.6646V89.6282C32.3442 89.897 32.4517 90.1546 32.6424 90.3439C32.8331 90.5332 33.091 90.6394 33.3599 90.6385H53.2631L50.5156 97.6081H43.8795C43.6111 97.6067 43.3536 97.7124 43.1629 97.9018C42.9723 98.0906 42.8647 98.3477 42.8638 98.6161C42.8625 98.8858 42.9696 99.1451 43.1602 99.3358C43.3509 99.5265 43.6098 99.6331 43.8795 99.6322H79.5152C79.784 99.6317 80.0415 99.5242 80.2308 99.3335C80.4206 99.1429 80.5263 98.8849 80.5254 98.6161C80.5232 98.0594 80.0718 97.609 79.5152 97.6081H72.8717L70.1261 90.6385H90.0351C90.5918 90.6362 91.0418 90.1849 91.0431 89.6283V54.6646C91.0454 54.1057 90.594 53.6507 90.0351 53.6485L33.3599 53.6484ZM34.3701 55.6725H89.0184V88.6121H34.3701V55.6725ZM46.0798 62.755C45.8358 62.7713 45.6063 62.8752 45.4333 63.0473C45.2431 63.2375 45.136 63.4951 45.136 63.7639C45.136 64.0327 45.2431 64.2907 45.4333 64.4805L47.8252 66.89L45.4333 69.2994V69.2999C45.2426 69.4896 45.1351 69.7481 45.1351 70.0174C45.1351 70.2866 45.2426 70.5446 45.4333 70.7348C45.6244 70.9246 45.8833 71.0308 46.1526 71.0294C46.4218 71.0276 46.6794 70.9192 46.8682 70.7271L49.2519 68.3276L51.6339 70.7271H51.6343C52.0269 71.1216 52.6644 71.1252 53.0611 70.7348C53.2532 70.546 53.362 70.2884 53.3638 70.0187C53.3652 69.7494 53.259 69.4906 53.0693 69.2999L50.6774 66.8904L53.0693 64.4809V64.4805C53.2586 64.2898 53.3643 64.0314 53.3625 63.7626C53.3611 63.4937 53.2527 63.2362 53.0611 63.0473C52.6644 62.657 52.0269 62.6606 51.6343 63.055L49.2524 65.4546L46.8687 63.055H46.8682C46.6617 62.8449 46.3739 62.7356 46.0798 62.755L46.0798 62.755ZM70.9739 62.755C70.7299 62.7713 70.5004 62.8752 70.3273 63.0473C70.1358 63.2362 70.0273 63.4937 70.026 63.7626C70.0246 64.0314 70.1299 64.2898 70.3192 64.4805L72.7111 66.89L70.3192 69.2994V69.2999C70.1295 69.4906 70.0233 69.7494 70.0251 70.0187C70.0264 70.2884 70.1353 70.546 70.3273 70.7348C70.518 70.9241 70.7764 71.0299 71.0453 71.0281C71.3145 71.0267 71.5716 70.9183 71.7605 70.7271L74.1401 68.3295L76.5202 70.7271C76.7091 70.9183 76.9662 71.0267 77.235 71.0281C77.5038 71.0299 77.7622 70.9241 77.9534 70.7348C78.1454 70.546 78.2543 70.2884 78.2556 70.0187C78.257 69.7494 78.1512 69.4906 77.9615 69.2999L75.5696 66.8904L77.9615 64.4809V64.4805C78.1508 64.2898 78.2561 64.0314 78.2547 63.7626C78.2529 63.4937 78.1445 63.2362 77.9534 63.0473C77.7622 62.858 77.5038 62.7528 77.235 62.7541C76.9662 62.7555 76.7091 62.8639 76.5202 63.055L74.1401 65.451L71.7605 63.055C71.5545 62.8454 71.2671 62.736 70.9739 62.755V62.755ZM61.6974 74.2612C58.3965 74.2612 55.7142 76.9688 55.7142 80.282V80.521C55.7128 80.7893 55.8185 81.0473 56.0074 81.238C56.1967 81.4282 56.4538 81.5362 56.7221 81.5371C56.9919 81.538 57.2508 81.4314 57.4419 81.2407C57.6325 81.05 57.7392 80.7907 57.7383 80.521V80.282C57.7383 78.0469 59.4912 76.2852 61.6974 76.2852C63.9035 76.2852 65.6565 78.0468 65.6565 80.282V80.521C65.6556 80.7898 65.7613 81.0478 65.9507 81.2384C66.1404 81.4291 66.398 81.5366 66.6663 81.5371C66.9351 81.5357 67.1918 81.4282 67.3811 81.238C67.5699 81.0473 67.6757 80.7893 67.6748 80.521V80.282C67.6748 76.9685 64.9982 74.2611 61.6973 74.2611L61.6974 74.2612ZM55.4452 90.6378H67.9518L70.6934 97.6074H52.6951L55.4452 90.6378Z",
    fill: "white",
    id: "path1"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 39C30.4934 39 39 30.4934 39 20C39 9.50659 30.4934 1 20 1C9.50659 1 1 9.50659 1 20C1 30.4934 9.50659 39 20 39Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 12.3984V19.9984",
    stroke: "#714787",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 27.6016H20.0201",
    stroke: "#714787",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14075_117895"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 13,
    width: 120,
    height: 120,
    rx: 60,
    fill: "white",
    id: "rect4"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      strokeWidth: 0.139884
    },
    d: "m 19.373988,20.632948 c -0.26727,-0.26727 -0.279768,-0.466281 -0.279768,-4.45462 0,-3.973755 0.01325,-4.186845 0.275133,-4.423844 0.382119,-0.345813 0.982489,-0.316142 1.290113,0.06376 0.231572,0.285979 0.253251,0.664666 0.253251,4.423844 0,3.92458 -0.01269,4.123785 -0.279769,4.390861 -0.153873,0.153873 -0.437139,0.279769 -0.62948,0.279769 -0.192341,0 -0.475607,-0.125896 -0.62948,-0.279769 z",
    id: "path5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      strokeWidth: 0.139884
    },
    d: "m 19.315241,28.199076 c -0.332448,-0.367352 -0.231876,-0.973789 0.216793,-1.307229 0.594194,-0.441591 1.380683,-0.02938 1.380683,0.723632 0,0.768635 -1.074706,1.161251 -1.597476,0.583597 z",
    id: "path6"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataAvailable);
export default __webpack_public_path__ + "static/media/noDataAvailable.7677394e742bdd3cfd678d175a4df77a.svg";
export { ForwardRef as ReactComponent };